/**
 * Search input
 */

import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { SearchWrapper, SearchButton } from './elements';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
// import { useLocalStorage } from 'utils/hooks';
import { openSearchModal } from 'context/modal/actions';
import { useStateValue } from 'context/store';

export function Search({ res, buttonPadding, history, ...rest }) {
  const { dispatch } = useStateValue();

  return (
    <SearchWrapper onClick={() => dispatch(openSearchModal())} {...rest}>
      <SearchButton buttonPadding={buttonPadding}>
        <SearchIcon /> <span>Search</span>
      </SearchButton>
    </SearchWrapper>
  );
}

Search.propTypes = {
  width: PropTypes.string
};

export default withRouter(Search);
